import { EasmAssetsInventoryGridWebComponent } from './component/EasmAssetsInventoryGridWebComponent';
import { WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID } from '../../webcomponents.constants';

export { EasmAssetsInventoryGridWebComponent };

window.customElements.define(WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID, EasmAssetsInventoryGridWebComponent);
